export const SUMMATIVE_TEST_PAGE_DESCRIPTION = `
Prepare comprehensive summative tests on any topic. You can also add subtopics for a more focused approach. Each generation that costs 4 credits will give you up to 50 questionnaire with answer key and Table of Specifications.`;

export const IB_SUMMATIVE_TEST_PAGE_DESCRIPTION = `Prepare comprehensive summative tests on any topic. You can also add subtopics for a more focused approach. Each generation that costs 4 credits will give you up to 50 questionnaire with answer key on your selected assessment type.`;
export const SUMMATIVE_TEST_HEADING = 'test title';
export const SUMMATIVE_TEST_HEADING_FILIPINO = 'mahabang pagsusulit';

export const MULTIPLE_CHOICE_LAST_OPTION = 'D';
